export enum HotFeatureFlags {
    None = 'NONE' // Added for making build work, please remove once new FF introduced
}
